module.exports = {
  title: 'Fat Atom',
  description: `
    This was the new website for my previous employer, Fat Atom, that I was given the design for. It was then converted into an easy to edit WordPress theme.
  `,
  tags: ['CSS', 'JavaScript', 'PHP', 'WordPress',],
  images: [require('./images/1.jpg'), require('./images/2.jpg'), require('./images/3.jpg'),],
};



// WEBPACK FOOTER //
// ./src/data/works/fatatom/index.js